module.exports = __webpack_public_path__ + "img/MW-mob.37892e04.jpg";